import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import './pagination.scss';

const seperator = <li className="Pagination__Page Pagination__Page--separator">. . .</li>;

class Pagination extends React.PureComponent {
  getPagination = () => {
    const {numFound, resultsPerPage, numberOfPagesOnBar, currentPage} = this.props;
    const lastPage = Math.ceil(numFound / resultsPerPage);

    const pagination = {
      pages: [],
      numFound,
      resultsPerPage,
      currentPage,
      previousPage: currentPage - 1,
      nextPage: currentPage + 1,
      lastPage,
      showPreviousArrow: currentPage > 1,
      showNextArrow: currentPage < lastPage,
      showFirstPage: currentPage >= 3,
      showLastPage: currentPage <= lastPage - 2,
      showSeparator: lastPage > numberOfPagesOnBar,
    };

    if (lastPage > 1) {
      for (let i = 0; i < numberOfPagesOnBar; i++) {
        if (!i && currentPage - 1 !== 0) {
          pagination.pages.unshift(currentPage - 1);
        }

        if (currentPage + i <= lastPage) {
          pagination.pages.push(currentPage + i);
        }
      }
    }

    return pagination;
  };

  onPageChange = (e, pageNumber) => {
    e.preventDefault();
    const {onPageChange} = this.props;
    onPageChange && onPageChange(pageNumber);
  };

  render() {
    const {numFound, resultsPerPage, className} = this.props;

    const showPagination = numFound > resultsPerPage;

    let paginationSection;

    if (showPagination) {
      const pagination = this.getPagination();
      paginationSection = (
        <div className={cs('Pagination__Container', className)}>
          <ul className="Pagination__Pages">
            {pagination.showPreviousArrow && (
              <li className="Pagination__Page">
                <a
                  href={`?p=${pagination.previousPage}`}
                  aria-label="previous"
                  onClick={(e) => this.onPageChange(e, pagination.previousPage)}
                >
                  <i className="Pagination__Page--Previous sh-iconset sh-iconset-chevron" />
                </a>
              </li>
            )}
            {pagination.showFirstPage && (
              <>
                <li className="Pagination__Page">
                  <a href="?p=1" aria-label="first" onClick={(e) => this.onPageChange(e, 1)}>
                    1
                  </a>
                </li>
                {seperator}
              </>
            )}
            {pagination.pages.map((page) => {
              if (page !== pagination.currentPage) {
                return (
                  <li key={`Pagination__Page-${page}`} className="Pagination__Page">
                    <a href={`?p=${page}`} onClick={(e) => this.onPageChange(e, page)}>
                      {page}
                    </a>
                  </li>
                );
              }

              return (
                <li key={`Pagination__Page-${page}`} className="Pagination__Page Pagination__Page--CurrentPage">
                  {pagination.currentPage}
                </li>
              );
            })}
            {pagination.showSeparator && pagination.showLastPage && seperator}
            {pagination.showLastPage && (
              <li className="Pagination__Page">
                <a
                  href={`?p=${pagination.lastPage}`}
                  aria-label="last"
                  onClick={(e) => this.onPageChange(e, pagination.lastPage)}
                >
                  {pagination.lastPage}
                </a>
              </li>
            )}
            {pagination.showNextArrow && (
              <li className="Pagination__Page">
                <a
                  href={`?p=${pagination.nextPage}`}
                  aria-label="next"
                  onClick={(e) => this.onPageChange(e, pagination.nextPage)}
                >
                  <i className="Pagination__Page--Next sh-iconset sh-iconset-chevron" />
                </a>
              </li>
            )}
          </ul>
        </div>
      );
    }

    return showPagination ? paginationSection : null;
  }
}

Pagination.propTypes = {
  numFound: PropTypes.number,
  resultsPerPage: PropTypes.number,
  currentPage: PropTypes.number,
  numberOfPagesOnBar: PropTypes.number,

  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
  onPageChange: PropTypes.func,
};

Pagination.defaultProps = {
  numberOfPagesOnBar: 2,
  currentPage: 1,
};

export default Pagination;
